# Nostr ecosystem
https://nostr.com
https://nostr.how
https://nostr.directory
https://nostr.watch
https://nostrapps.com
https://njump.me
https://iris.to
https://primal.net
https://habla.news
https://zap.stream
https://wikifreedia.xyz
https://shopstr.store
https://satellite.earth
https://nos.social
https://coracle.social
https://snort.social
https://amethyst.social
https://nostrudel.ninja
https://ditto.pub
https://fountain.fm
https://wavlake.com
https://zap.cooking
https://nostr.build
https://nostrface.com
https://nostrcheck.me
https://nostr.band
https://nostr.today
https://nostr.world
https://nostrplebs.com
https://nostrich.love
